import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="container-custom">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className={`ri-fire-fill text-xl ${isHome && !isScrolled ? 'text-background-50' : 'text-primary-500'}`}></i>
            </div>
            <span className={`font-heading font-bold text-lg whitespace-nowrap ${
              isHome && !isScrolled ? 'text-background-50' : 'text-foreground-950'
            }`}>
              黑料网在线
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? isHome && !isScrolled
                    ? 'text-background-50 bg-background-50/20'
                    : 'text-primary-600 bg-primary-50'
                  : isHome && !isScrolled
                    ? 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-600 bg-primary-50'
                    : isHome && !isScrolled
                      ? 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                      : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-50'
                  : isHome && !isScrolled
                    ? 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              isHome && !isScrolled ? 'text-background-50' : 'text-foreground-950'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="container-custom py-3 flex flex-col gap-1">
            <Link to="/" className="px-3 py-2.5 text-sm font-medium rounded-md text-foreground-600 hover:text-foreground-950 hover:bg-background-100 transition-colors">
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-3 py-2.5 text-sm font-medium rounded-md text-foreground-600 hover:text-foreground-950 hover:bg-background-100 transition-colors">
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-3 py-2.5 text-sm font-medium rounded-md text-foreground-600 hover:text-foreground-950 hover:bg-background-100 transition-colors">
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}